export default __webpack_public_path__ + "static/media/28.88fb78e3.jpg";